import React from 'react'
import { Button } from '@/components/ui/button'
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react'

interface ApiPaginationProps {
  currentPageIndex: number
  totalPages: number
  hasNextPage: boolean
  isFetching?: boolean
  onPrevious: () => void
  onNext: () => void | Promise<void>
  className?: string
  variant?: 'buttons' | 'minimal'
  loadingText?: string
  nextText?: string
  previousText?: string
  showPageCount?: boolean
}

 const ApiPagination: React.FC<ApiPaginationProps> = ({
  currentPageIndex,
  totalPages,
  hasNextPage,
  isFetching = false,
  onPrevious,
  onNext,
  className = '',
  variant = 'buttons',
  loadingText = 'Loading...',
  nextText = 'Next Page',
  previousText = 'Previous Page',
  showPageCount = true
}) => {
  const isNextDisabled = !hasNextPage || isFetching;
  const isPreviousDisabled = currentPageIndex === 0

  if (variant === 'minimal') {
    return (
      <div className={`flex items-center justify-center gap-4  ${className}`}>
        <Button
          variant="outline"
          onClick={onPrevious}
          disabled={isPreviousDisabled}
          className="flex items-center gap-2 rounded-md"
        >
          <ChevronLeftIcon className="h-4 w-4" />
        <span className='w-20 text-center'>Previous</span> 
        </Button>

    

        <Button
          variant="outline"
          onClick={onNext}
          disabled={isNextDisabled}
          className="flex items-center gap-2 rounded-md"
        >
          <span className='w-20 text-center'>{isFetching ? loadingText : 'Next'}</span>
          <ChevronRightIcon className="h-4 w-4" />
        </Button>
      </div>
    )
  }

  return (
    <div className={`flex items-center justify-center gap-4 mt-6 ${className}`}>
      <Button
        variant="outline"
        onClick={onPrevious}
        disabled={isPreviousDisabled}
        className="flex items-center gap-2"
      >
        <ChevronLeftIcon className="h-4 w-4" />
        {previousText}
      </Button>

      {showPageCount && (
        <span className="text-sm font-medium">
          Page {currentPageIndex + 1} of {totalPages}
        </span>
      )}

      <Button
        variant="outline"
        onClick={onNext}
        disabled={isNextDisabled}
        className="flex items-center gap-2"
      >
        {isFetching ? loadingText : nextText}
        <ChevronRightIcon className="h-4 w-4" />
      </Button>
    </div>
  )
}

export default ApiPagination;